<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-Sub-Ticket" data-toggle="modal" data-target="#exampleModal">Add</button>

            <div class="personal-details">
                <h4 class="personal-details-title">Task Master</h4>
                <table class="table table-striped" >
                    <thead>
                      <tr>
                        <th scope="col">Task Group Name</th>
                        <th scope="col">Task Group</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let taskMasters of taskMasters;let i = index">
                        <th scope="col">{{taskMasters.taskGroupName}}</th>
                        <th scope="col"><a (click)="getTaskMasterById(taskMasters.taskMasterId)" data-toggle="modal" data-target="#viewTask">view tasks</a></th>
                      </tr>
                         
                    </tbody>
                </table>
            </div> -->


            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>Task Master</p>
                  </div>
                  <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                            <!-- <i class="bi bi-x-lg"></i> -->
                            <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search product" [(ngModel)]="searchKey">
                      </form>
                      <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>
  
                      <i class="bi bi-search" (click)="getTaskMasterByWildSearch(0,10)"></i>
                    </div>
                      <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 50%;">Task Group Name</th>
                        <th style="width: 50%;">Task Group</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let taskMasters of taskMasters | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 50%;">{{taskMasters.taskGroupName}}</p>
                      <p style="width: 50%;"><a (click)="getTaskMasterById(taskMasters.taskMasterId)" data-toggle="modal" data-target="#viewTask">view tasks</a></p>               
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && taskMasters.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>

        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="form">
            <!-- <div class="form-group">
                <label>Task Name</label>
                <input formControlName="taskGroupName" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label>Task Description</label>
                <textarea name="" formControlName="description" id="" class="form-control" cols="30" rows="10"></textarea>
            </div>
            <div class="form-group">
                <label>Task SlNo</label>
                <input formControlName="taskSlNo" type="text" class="form-control">
            </div> -->

            <div class="row">
                <!-- <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Task Name</label>
                        <input formControlName="taskGroupName" type="text" class="form-control">
                    </div>
                </div>
                
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Task SlNo</label>
                        <input formControlName="taskSlNo" type="text" class="form-control">
                    </div>
                </div> -->
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>Task Group Name</label>
                        <input type="text" formControlName="taskGroupName" id="" class="form-control">
                    </div>
                </div>
              </div>
              <div class="">
                <div formArrayName="taskGroup">
                    <div *ngFor="let task of form.controls.taskGroup['controls'];let i = index;let last = last" [formGroupName]="i">
                        <div class="row">
                            <div class="col-md-3 col-lg-3" style="padding: 0 5px 0 15px;">
                                <div class="form-group">
                                    <input formControlName="seqNo" type="text" placeholder="enter seqNo" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4" style="padding: 0 5px;">
                                <div class="form-group">
                                    <input formControlName="name" placeholder="enter name" type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4" style="padding: 0 5px;">
                                <div class="form-group">
                                    <input formControlName="description" placeholder="enter description" type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-1 col-lg-1 taskBtn" *ngIf="last">
                                <svg xmlns="http://www.w3.org/2000/svg" (click)="addTaskGroup()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removeTaskGroupObject(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                </svg>
                            </div>
                            <div class="col-md-1 col-lg-1 taskBtn1" *ngIf="!last">
                                <svg xmlns="http://www.w3.org/2000/svg" (click)="removeTaskGroupObject(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
              </div>


        </div>

   
      <div class="modal-footer">
        <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addTaskMaster()" class="btn btn-primary">Add</button>
      </div>
    </div>
  </div>
</div>
</div>

<div class="modal fade" id="viewTask" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Tasks
            <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <div class="status-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 20%;">seqNo</th>
                  <th style="width: 20%;">name</th>
                  <th style="width: 60%;">description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let task of singleTaskMasters">
                  <td>{{task.seqNo}}</td>
                  <td>{{task.name}}</td>
                  <td>{{task.description}}</td>
                </tr>
              </tbody>
            </table>
          </div>
     
          <div class="modal-footer">
            <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
